import React from "react";
import styled from "styled-components";
import { ReactComponent as RejectionMarker } from "assets/icons/rejection.svg";
import AccordionComponent from "./accordion";

const Container = styled.ul`
    background-color: #f8e9e9;
    padding: 0 16px;
    display: flex;
    flex-direction: column;
    gap: 5px;

    li {
        display: flex;
        gap: 5px;
    }
`;

const TitleContainer = styled.div`
    display: flex;
    gap: 8px;

    svg {
        width: 16px;
        height: 16px;
    }
`;

const Title = styled.h4`
    font-size: 16px;
    font-weight: 500;
    color: #bd271e;
`;

const ObjectionItem = styled.p`
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    color: #343741;
`;

const ObjectionReason = styled.p`
    font-size: 14px;
    font-weight: 600;
    color: #343741;
    white-space: pre-line;
`;

const RejectionList = ({ objections }) => {
    const getObjetionsList = () => {
        const lastLevelAttributes = Object.entries(objections).flatMap(([key, value]) =>
            Object.entries(value).map(([subKey, subValue]) => ({ [subKey]: subValue }))
        );
        return lastLevelAttributes;
    };

    const AccordionTitle = () => (
        <TitleContainer>
            <RejectionMarker />
            <Title>{getObjetionsList().length} Rejected info</Title>
        </TitleContainer>
    );

    return (
        <AccordionComponent
            title={AccordionTitle()}
            body={
                <Container>
                    {getObjetionsList().map((objection, index) => {
                        const [key, value] = Object.entries(objection)[0];
                        return (
                            <li key={index}>
                                <ObjectionItem>{key}:</ObjectionItem>
                                <ObjectionReason>{value}</ObjectionReason>
                            </li>
                        );
                    })}
                </Container>
            }
            backgroundColor="#F8E9E9"
            arrowColor="#BD271E"
            padding="16px"
        />
    );
};

export default RejectionList;
